import React, { useState } from 'react';
import { styled } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { Colors } from 'library';
import { FieldGroup, IconButton, Modal, Row, Stack, Text } from 'library/ui';

export const LabeledField = ({
    label,
    help,
    image,
    required,
    children,
}: {
    label: string;
    help: React.ReactNode;
    image?: string;
    required?: boolean;
    children: React.ReactNode;
}) => {
    const [helpOpen, setHelpOpen] = useState(false);
    return (
        <Stack gap="sm">
            <Row gap="sm" align="center">
                <FieldGroup
                    label={label}
                    required={required}
                    help={
                        <IconButton
                            icon={HelpOutline}
                            onClick={() => setHelpOpen(true)}
                            tooltip="How do I find this?"
                            size={24}
                            iconSize={16}
                        />
                    }
                >
                    {children}
                </FieldGroup>
            </Row>
            {helpOpen && (
                <Modal title={`How to find: ${label}`} onClose={() => setHelpOpen(false)} width={760}>
                    <Stack gap="md">
                        {typeof help === 'string' ? <Text tone="secondary">{help}</Text> : help}
                        <ScreenshotFrame>
                            {image ? <ScreenshotImg src={image} alt={label} /> : 'Screenshot goes here'}
                        </ScreenshotFrame>
                    </Stack>
                </Modal>
            )}
        </Stack>
    );
};

const ScreenshotFrame = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 220,
    borderRadius: 10,
    border: `1px dashed ${Colors.border}`,
    backgroundColor: Colors.surface,
    color: Colors.textSecondary,
    overflow: 'hidden',
});

const ScreenshotImg = styled('img')({
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
});
